import axios from 'axios'
import { Message } from 'element-ui'

const request = axios.create({
  baseURL: 'https://www.metabhub.net'
})

request.interceptors.response.use(
  response => {
    if (response.config && response.config.responseType === 'blob') {
      return response
    }
    const res = response.data
    if (res.code !== undefined && res.code !== 200) {
      Message.error(res.message || 'Request failed')
      return Promise.reject(new Error(res.message || 'Request failed'))
    }
    return res.code !== undefined ? res.data : res
  },
  error => {
    Message.error(error.message || 'Network error')
    return Promise.reject(error)
  }
)

export default request

export function downloadFile(url, params = {}, fallbackFilename = 'download.tsv') {
  return request({
    url,
    method: 'get',
    params,
    responseType: 'blob'
  }).then((response) => {
    const blob = response.data instanceof Blob ? response.data : response
    const disposition = response.headers ? response.headers['content-disposition'] : ''
    let filename = fallbackFilename

    if (disposition) {
      const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
      const plainMatch = disposition.match(/filename="?([^"]+)"?/i)
      const rawName = utf8Match ? utf8Match[1] : (plainMatch ? plainMatch[1] : '')
      if (rawName) {
        filename = decodeURIComponent(rawName)
      }
    }

    const objectUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(objectUrl)
  }).catch((error) => {
    Message.error(error.message || 'Download failed')
    return Promise.reject(error)
  })
}
